module.exports = new __parcel__URL__("box.2a34708a.webp").toString();